import React, { useEffect, useState, useRef } from 'react';
//import { Link, useNavigate } from "react-router-dom";
import { httpRequest, httpAuthHeaders } from '../../../../services/httpService';
import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
import Loader from '../../../parts/Loader';
//import InputText from '../elements/InputText';
import RenderErrors from '../../../elements/RenderErrors';
import InputTextArea from '../../../elements/InputTextArea';
import ButtonGroupSelection from '../../../elements/ButtonGroupSelection';
import store from '../../../../services/store';
import helpers from '../../../../services/helpers';
import { getApiData } from '../../../../services/apiService';
import ContactListModal from '../../../modals/ContactListModal';
import Swal from 'sweetalert2';
import { InputMask } from 'primereact/inputmask';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
 
export default function VehiclesSearchModal ({
        is_show = false, 
        setShow, 
        handleSave, 
        header_title="Vehicle Records",
        index="",
        handleSelect
    }){
    const toast = useRef(null);
    const [loading, setLoading] = useState(0);
    const [notice, setNotice] = useState('');

    const [form_loaded, setFormLoaded] = useState(0);
    const [errors, setErrors] = useState([]);
    const [data_table, setDataTable] = useState([]);

    const [customer_modal, setContactModal] = useState(0);
    const [search_key, setSearchKey] = useState("");
    const [datatable_state, setDataTableState] = useState({
        first: 0,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null
    });
   
    useEffect(() => {
        setErrors([])

        if(is_show){
            console.log('captured index', index)
            setSearchKey(null)
            //setDataTable(null)
        }
    }, [is_show]);
    
    useEffect(() => {
        fetchData()
    }, [datatable_state.page]);
   
    useEffect(() => {
        fetchData()
    }, [search_key]);
    

    function fetchData(){
        const page = datatable_state.page
        const per_page = datatable_state.rows

       // let filter = `?search=${search_key}&paginate=1&`

        let filter = `?paginate=1&`
        
        if(page){
            filter += 'page='+page+'&'
        }
        if(per_page){
            filter += 'per_page='+per_page+'&'
        }
        if(search_key){
            filter += 'search='+search_key+'&'
        }

        filter = filter.slice(0, -1)

        //return
        const url = helpers.createShipBookingHubUrl(`vehicles${filter}`)

        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            displayDataTable(res)
            setLoading(0)
            setFormLoaded(1)
        })
        .catch((err) => {
            setLoading(0)
            setFormLoaded(0)

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    
                }
            })
        }); 
    }


    
    function displayDataTable(data){
        setDataTable(
            <DataTable 
                className='border-top'
                dataKey={data.id}
                value={data.data} 
                // tableStyle={{ minWidth: '50rem' }}
                size="small"
                paginator 
                rows={data.per_page} 
                //rowsPerPageOptions={[5, 10, 20, 25, 50]}
                totalRecords={data.total}
                onPage={onPage}
                first={datatable_state.first}
                lazy
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                //selection={selected_items} 
                //onSelectionChange={onSelectItem}
                scrollHeight="500px"
                scrollable
                responsive={true}
                emptyMessage="No data to display"
            >
                <Column field="id" header="ID" />
                <Column field="plate_number" header="Plate No" />
                <Column 
                    field="brand" 
                    header="Brand" 
                    body={({brand})=> brand ? brand:'---'}
                />
                <Column 
                    field="model_name" 
                    header="Model Name" 
                    body={({model_name})=> model_name ? model_name:'---'}
                />
                <Column field="year_model" header="Year Model" />

                <Column 
                    // header="Customer/Owner" 
                    headerStyle={{ width: '3rem' }}
                    body={(rowData)=> <button type="button" className='btn btn-primary btn-sm' onClick={(e) => onSelect(rowData)} >Select</button>}
                />
                {/* <Column field="customer_name" header="Customer/Owner" /> */}
                {/* <Column 
                    header="Customer/Owner" 
                    body={({customer_id, customer_name})=> <Link to={`/customers/${customer_id}/edit`}>{customer_name}</Link>}
                />
                <Column 
                    field="driver" 
                    header="Driver" 
                    body={({driver})=> driver ? driver:'---'}
                />
                <Column className="text-right" body={displayActionMenu} style={{ maxWidth: '100px' }}></Column>  */}
            </DataTable>
        )

    }

    function handleClose(e) {
        reset();
        setShow(0);
    }

    function reset(){
        setNotice('')
    }

    const onPage = (e) => {
        setDataTableState(e)
        //setSelectedItems([])
    };

    function onSelect(e){
        setShow(0);
        handleSelect(e)
    }

    return (
        <>
            <Toast ref={toast} position="top-center" />

            <Dialog 
                visible={is_show} 
                position="top" 
                header={header_title} 
                style={{ width: '60vw' }} 
                breakpoints={{ 
                    '960px': '75vw', // On Tablet (screen < 960px), use 75% width
                    '641px': '95vw'  // On Mobile (screen < 641px), use 95% width
                }}
                onHide={handleClose} 
                //footer={footerContent}
            >
                <Loader isLoading={loading}/>
                    <div className="row mt-2">
                        {/* <div className="col-12">
                            <label>Plate Number<span className="text-danger">*</span></label>
                        </div> */}
                        <div className="col-12 form-group">
                            <InputText
                                id="search_key" 
                                name="search_key" 
                                value={search_key}
                                tagClass="form-control mb-0"
                                placeholder="Search Plate Number"
                                onChange={(e) => setSearchKey(e.target.value)}
                                className='w-100'
                                autoFocus
                            />
                        </div>
                    </div>


                    <div>
                        {data_table}
                    </div>
            </Dialog>
        </>
    )
}